import classnames from "classnames";
import { ComponentPropsWithoutRef, useState } from "react";
import Spinner from "./Spinner";

type Props = ComponentPropsWithoutRef<"button"> & {
  icon: React.ReactNode;
  variant?: "primary" | "alert" | "secondary" | "danger";
  loading?: boolean;
};

export default function IconButton({
  icon,
  className,
  disabled,
  loading = false,
  variant,
  ...rest
}: Props) {
  const [spinnerShown, setSpinnerShown] = useState(false);

  return (
    <button
      className={classnames(
        "flex justify-center items-center rounded-lg disabled:cursor-not-allowed cursor-pointer relative px-2 py-1 text-xs disabled:bg-slate-300 disabled:hover:bg-slate-300 disabled:text-white",
        {
          "bg-blue-600 text-white hover:bg-blue-500": variant === "primary",
          "bg-red-100 text-red-800 hover:bg-red-50": variant === "alert",
          "bg-white border border-slate-300 text-slate-700 hover:bg-slate-50":
            variant === "secondary",
          "bg-red-5 text-red-5 hover:bg-red-50": variant === "danger",
          "bg-white text-black hover:bg-gray-100": !variant,
        },
        className,
      )}
      disabled={disabled || loading}
      {...rest}
    >
      <Spinner
        show={loading}
        onDebouncedChange={(on) => setSpinnerShown(on)}
        parentClassName="absolute size-4"
      />
      <div className={classnames({ invisible: spinnerShown })}>{icon}</div>
    </button>
  );
}
